import { scribbleGenerator } from "./_scribbleGenerator";

/**
 * scribble関数
 * 
 * ページ内のすべての.scribbleクラスを持つ要素に対して、
 * 落書きアニメーションを初期化します。
 * 各要素は独立したscribbleGeneratorインスタンスを持ち、
 * それぞれ異なる設定で動作可能です。
 */
export function scribble() {
  // .scribbleクラスを持つすべての要素を取得
  const allScribbleEls = document.querySelectorAll(".scribble");
  // 作成されたインスタンスを保持する配列（必要に応じて後で操作可能）
  const instances = [];
  
  // .scribble要素が存在する場合のみ処理
  if (allScribbleEls.length) {
    // 各要素に対してscribbleGeneratorインスタンスを作成
    allScribbleEls.forEach((el) => {
      const sg = new scribbleGenerator(el);
      instances.push(sg);
    });
    
    // タブの表示状態を監視
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        // タブが非アクティブになったら、すべてのアニメーションを停止
        instances.forEach(instance => {
          if (instance.pause) instance.pause();
        });
      } else {
        // タブがアクティブになったら、すべてのアニメーションを再初期化
        instances.forEach(instance => {
          if (instance.restart) instance.restart();
        });
      }
    });
  }
  
  // クリーンアップ用にインスタンスを返す
  return instances;
}